module.exports = __webpack_public_path__ + "static/media/Post_USP_16.07.18.ca2327ad.jpg";